import { NOTIFICATION_STATUSES, STEP_STATUS } from "../notifications.consts";
import dayjs from "dayjs";

export const getNotificationStepText = (status, steps) => {
  if (status === NOTIFICATION_STATUSES.CANCELED) {
    return "";
  }

  if (status === NOTIFICATION_STATUSES.IN_PROGRESS) {
    const inProgressStep = steps?.findIndex(step => !step.status || step.status === STEP_STATUS.IN_PROGRESS);
    if (inProgressStep !== -1) return `Step ${inProgressStep + 1} of ${steps.length}`;
  }

  if (status === NOTIFICATION_STATUSES.FAILED) {
    const failedStep = steps?.findIndex(step => step.status === STEP_STATUS.FAILED);
    if (failedStep !== -1) return `${failedStep} of ${steps?.length} steps completed`;
  }

  return `${steps?.length} of ${steps?.length} steps completed`;
};

export const formatRelativeTime = (timestamp) => {
  const now = dayjs();
  const date = dayjs(timestamp);
  const diffInMinutes = now.diff(date, "minute");
  const diffInHours = now.diff(date, "hour");
  const diffInDays = now.diff(date, "day");
  const diffInWeeks = now.diff(date, "week");

  if (diffInMinutes < 1) return "now";
  if (diffInMinutes < 60) return `${diffInMinutes}m`;
  if (diffInHours < 24) return `${diffInHours}h`;
  if (diffInDays < 7) return `${diffInDays}d`;
  return `${diffInWeeks}w`;
};
